/**
 * 构造一个有效的随机url字符串
 * @param {*} length 字符串长度
 * @returns
 */
export function buildValidURLRandomString(length) {
    const str = '1234567890qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM';
    const result = [];
    for (let i = 0; i < length; i++) {
        const char = str[Math.floor(Math.random() * 62)];
        result.push(char);
    }
    return result.join('');
}
